import MasterPassLogo from '@core/assets/images/MasterPassLogo.webp'
import type { CardType } from '@deposit/api'

const SupportedDepositMethods: CardType[] = ['masterpass', 'masterpass_dp']

const Titles = {
    masterpass: 'MasterPass',
    masterpass_dp: 'MasterPass DP',
}

const Logos = {
    masterpass: MasterPassLogo,
    masterpass_dp: MasterPassLogo,
}

export default {
    SupportedDepositMethods: SupportedDepositMethods,
    Titles: Titles,
    Logos: Logos,
}
